import React from 'react';
import { ThemeContext } from '../../config/theme';
import { Brightness3, Brightness5 } from '@material-ui/icons';
import Switch from '@material-ui/core/Switch/Switch';

const DarkModeSwitch = () => {
  
  return (<ThemeContext.Consumer>
      {({ darkState, toggleTheme }) =>
        <>
          <Brightness5 />
          <Switch checked={darkState} onChange={toggleTheme} />
          <Brightness3 />
        </>
      }
    </ThemeContext.Consumer>
  );
};

export default DarkModeSwitch;